import request from "./client";

export const sendHeartbeat = async () => {
  const resp = await request.post("/v1/presence/heartbeat");
  return resp.body;
};
